import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";
import App from "./App";
import { ErrorProvider } from "./contexts/ErrorContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <StyledEngineProvider injectFirst>
    <MuiThemeProvider theme={theme}>
      <StyledComponentsThemeProvider theme={theme}>
        <ErrorProvider>
          <CssBaseline />
          <App />
        </ErrorProvider>
      </StyledComponentsThemeProvider>
    </MuiThemeProvider>
  </StyledEngineProvider>
);
reportWebVitals();
